export default __webpack_public_path__ + "static/media/Pao-Com-Chorico.f144dde5.jpg";